import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconJetSki: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13 2h2c3.4 0 7 3.2 7 8v1c0 2.8-2.2 5-5 5H5c-1.7 0-3-1.3-3-3 0-.8.3-1.6.9-2.1.5-.6 1.3-.9 2.1-.9h8c.5 0 1-.5 1-1v-.1c0-.2-.1-.4-.3-.6-.2-.2-.5-.3-.7-.3h-.1c-.8 0-1.5-.3-2-.9-.6-.6-.9-1.3-.9-2.1 0-1.7 1.3-3 3-3zm4 12c1.7 0 3-1.3 3-3v-1c0-3.5-2.6-6-5-6h-2c-.5 0-1 .4-1 1 0 .3.1.5.2.7.2.2.5.3.7.3h.1c.8 0 1.6.3 2.1.9.6.6.9 1.3.9 2.1 0 1.7-1.4 3-3 3H5c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7 0 .6.5 1 1 1h12zm-1.7 5.3c.5-.6 1.3-1.3 2.7-1.3 2 0 3.6 1.9 3.8 2.2.3.4.2 1.1-.2 1.4-.4.3-1.1.2-1.4-.2-.3-.4-1.3-1.4-2.2-1.4-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-1.4 0-2.2-.7-2.7-1.3-.5-.5-.7-.7-1.3-.7-.6 0-.8.2-1.3.7-.5.6-1.3 1.3-2.7 1.3-2 0-3.6-1.9-3.8-2.2-.3-.4-.2-1.1.2-1.4.4-.3 1.1-.2 1.4.2C4.1 19 5.1 20 6 20c.6 0 .8-.2 1.3-.7.5-.6 1.3-1.3 2.7-1.3 1.4 0 2.2.7 2.7 1.3.5.5.7.7 1.3.7.6 0 .8-.2 1.3-.7z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
